// localStorageに残るタスクを検出してDBにインポートするダイアログ
import { useEffect, useState } from 'react';
import { loadTasks as loadLocalTasks, loadHistory as loadLocalHistory, saveTasks } from '../lib/storage';
import { addTaskDb, appendReactionDb } from '../lib/db';
import { useAuth } from '../contexts/AuthContext';

const KEY_MIGRATED = 'ktv:migrated_to_db';

export default function MigrationDialog() {
  const { user, family } = useAuth();
  const [show, setShow] = useState(false);
  const [taskCount, setTaskCount] = useState(0);
  const [historyCount, setHistoryCount] = useState(0);
  const [importing, setImporting] = useState(false);

  useEffect(() => {
    if (!user || !family) return;
    if (localStorage.getItem(KEY_MIGRATED)) return;
    const tasks = loadLocalTasks();
    const history = loadLocalHistory();
    if (tasks.length === 0 && history.length === 0) {
      localStorage.setItem(KEY_MIGRATED, '1');
      return;
    }
    setTaskCount(tasks.length);
    setHistoryCount(history.length);
    setShow(true);
  }, [user, family]);

  const handleImport = async () => {
    if (!family || !user) return;
    setImporting(true);
    const tasks = loadLocalTasks();
    for (const t of tasks) {
      const { id, createdAt, ...rest } = t as any;
      await addTaskDb(rest, family.id, user.id);
    }
    const history = loadLocalHistory();
    for (const h of history) {
      const { id, ...rest } = h;
      await appendReactionDb(rest as any, family.id);
    }
    localStorage.setItem(KEY_MIGRATED, '1');
    // 元データは残しておく（消したい場合は社長判断）
    setImporting(false);
    setShow(false);
    window.location.reload(); // 再読み込みで反映
  };

  const handleSkip = () => {
    localStorage.setItem(KEY_MIGRATED, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="listening-overlay">
      <div className="box" style={{ maxWidth: 480 }}>
        <h2>📦 ローカルデータが見つかりました</h2>
        <p className="muted" style={{ marginBottom: 12 }}>
          このブラウザに以下のデータが残っています：
        </p>
        <ul style={{ textAlign: 'left', marginBottom: 16 }}>
          {taskCount > 0 && <li>📋 タスク: {taskCount}件</li>}
          {historyCount > 0 && <li>📜 履歴: {historyCount}件</li>}
        </ul>
        <p className="muted" style={{ marginBottom: 16 }}>
          クラウドに移して、他の端末でも見られるようにしますか？
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <button className="btn btn-primary" onClick={handleImport} disabled={importing}>
            {importing ? 'インポート中...' : '✅ インポートする'}
          </button>
          <button className="btn btn-secondary" onClick={handleSkip} disabled={importing}>
            スキップ
          </button>
        </div>
      </div>
    </div>
  );
}
